 <template>
  <div
    class="layout--main"
    :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]"
  >
    <v-nav-menu
      :navMenuItems="filteredNav"
      :title="getSystemSettings.systemName"
      parent=".layout--main"
    />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
          :navMenuItems="filteredNav"
        />
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6"
              >
                <!-- <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>-->

                <!-- BREADCRUMB -->
                <!-- <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                  :isRTL="$vs.rtl"
                />-->

                <!-- DROPDOWN -->
                <!-- <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/pages/profile').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="UserIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/apps/todo').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="CheckSquareIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/apps/email').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="MailIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>-->
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
// import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";

import { helperMixin } from "../../mixin/helperMixin";

import { mapGetters } from "vuex";

export default {
  mixins: [helperMixin],
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
  },
  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItems: [
         {
          url: "/dashboard/adminDashboard",
          name: "Dashboard Admin",
          slug: "dashboardAdmin",
          icon: "HomeIcon",
          permissionName: "Dashboard Admin"
        },
         {
          url: "/dashboard/clientDB",
          name: "Dashboard",
          slug: "Dashboard",
          icon: "HomeIcon",
          permissionName: "Dashboard Client"
        },
        // {
        //   url: null,
        //   name: "Dashboard",
        //   tag: "2",
        //   tagColor: "warning",
        //   icon: "HomeIcon",
        //   i18n: "Dashboard",
        //    permissionName: "Dashboard",
        //   submenu: [
        //     {
        //       url: "/db/analytics",
        //       name: "Analytics",
        //       slug: "dashboard-analytics",
        //       i18n: "Analytics",
        //        permissionName: "Dashboard",
        //     }, 
        //   ],
        // },
        {
          url: "/form/cases/allCases", 
          name: "All Cases",
          icon: "BriefcaseIcon",
          slug: "Cases",
          i18n: "Cases",
          permissionName: "Case", 
        },
        {
          url: "/form/cases/yourCases",
          name: "Cases",
          icon: "BriefcaseIcon",
          slug: "Cases",
          i18n: "Cases",
          permissionName: "Client Case", 
        },
        {
          url: "/form/wo/all",
          name: "Work Orders",
          icon: "CommandIcon",
          slug: "workOrders",
          i18n: "workOrders",
          permissionName: "workOrders",
        },
        {
          url: "/form/cars/vehicles",
          name: "All Vehicles",
          icon: "TruckIcon",
          slug: "vehicles",
          i18n: "vehicles",
          permissionName: "All Vehicles",
        },
        {
          url: "/form/cars/yourVehicles",
          name: "Your Vehicles",
          icon: "TruckIcon",
          slug: "yourvehicles",
          i18n: "yourvehicles",
          permissionName: "Client Vehicles",
        },
        {
          url: "/view/clients",
          name: "Clients",
          icon: "UserIcon",
          slug: "Clients",
          i18n: "Clients",
          permissionName: "Clients",
        },
        {
          url: "/form/su/client",
          name: "Car Summons",
          icon: "CommandIcon",
          slug: "Summons",
          i18n: "Summons",
          permissionName: "Summons",
        },
        {
          url: "/form/su/all",
          name: "All Summons",
          icon: "CommandIcon",
          slug: "allSummons",
          i18n: "allSummons",
          permissionName: "All Summons",
        },

        {
          url: null,
          name: "Report",
          icon: "BriefcaseIcon",
          i18n: "Report",
          permissionName: "Admin report",
          submenu: [
            {
              url: "/report/thecases",
              name: "Cases",
              slug: "cases",
              i18n: "View",
              permissionName: "Admin report"
            }, 
            {
              url: "/report/theworkorders",
              name: "Work Order",
              slug: "wo",
              i18n: "View",
              permissionName: "Admin report"
            }, 
            {
              url: "/report/summons",
              name: "Summons",
              slug: "Summons",
              i18n: "View",
              permissionName: "Admin report"
            }, 
          ]
        },

        {
          header: "Settings",
          icon: "PieChartIcon",
          i18n: "ChartsAndMaps",
          permissionName: "Settings",
          items: [
            {
              url: "/settings",
              name: "System Settings",
              icon: "SettingsIcon",
              slug: "settings",
              i18n: "Settings",
              permissionName: "System Settings",
            },

            {
              url: null,
              name: "Master Tables",
              icon: "GridIcon",
              tagColor: "success",
              i18n: "Charts",
              permissionName: "Master Tables",
              submenu: [
                {
                  url: "/view/summonstatuses",
                  name: "Summon Status",
                  slug: "summonstatuses",
                  i18n: "summonstatuses",
                  permissionName: "Summon Status",
                },
                {
                  url: "/view/vechiclestatuses",
                  name: "Vechicle Status",
                  slug: "Vechicle Status",
                  i18n: "Vechicle Status",
                  permissionName: "Vechicle Status",
                },
                {
                  url: "/view/agencies",
                  name: "Agencies",
                  slug: "agencies",
                  i18n: "agencies",
                  permissionName: "Agencies",
                },
                {
                  url: "/view/carmakes",
                  name: "Car Make",
                  slug: "carmakes",
                  i18n: "carmakes",
                  permissionName: "Car Make",
                },
                {
                  url: "/view/billtos",
                  name: "Bill To",
                  slug: "billTo",
                  i18n: "billTo",
                  permissionName: "billTo",
                },
                {
                  url: "/view/casecategories",
                  name: "Case Category",
                  slug: "casecategories",
                  i18n: "casecategories",
                  permissionName: "Case Category",
                },
                // {
                //   url: "/view/workordercategories",
                //   name: "Work Order Category",
                //   slug: "workordercategories",
                //   i18n: "workordercategories",
                //   permissionName: "WO Category",
                // },
                {
                  url: "/view/locations",
                  name: "Locations",
                  slug: "Locations",
                  i18n: "Locations",
                  permissionName: "Locations",
                },

                {
                  url: "/view/users",
                  name: "System Users",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "System Users",
                },

                {
                  url: "/form/roles/role",
                  name: "User Roles",
                  slug: "usergroups",
                  i18n: "userGroups",
                  permissionName: "User Roles",
                },

                {
                  url: "/view/pages",
                  name: "Pages",
                  slug: "pages",
                  i18n: "pages",
                  permissionName: "Pages",
                },
              ],
            },
          ],
        },
      ],

      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.main.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    },
  },
  computed: {
    ...mapGetters({
      getPermissions: "auth/getPermissions",
      getSystemSettings: "auth/getSystemSettings",
    }),
    filteredNav() {
      var menuItemCopy = this.navMenuItems;

      if (this.getPermissions != null) {
        var myPermission = this.getPermissions;
        var mainFilter = menuItemCopy.filter((f) =>
          myPermission.includes(f.permissionName)
        );

        //filter sub menus
        mainFilter.forEach((element) => {
          if (this.isset(element, "submenu")) {
            element.submenu = element.submenu.filter((f) =>
              myPermission.includes(f.permissionName)
            );
          }

          if (this.isset(element, "items")) {
            element.items = element.items.filter((f) =>
              myPermission.includes(f.permissionName)
            );

            element.items.forEach((el) => {
              if (this.isset(el, "submenu")) {
                el.submenu = el.submenu.filter((f) =>
                  myPermission.includes(f.permissionName)
                );
              }
            });
          }
        });

        return mainFilter;
      } else {
        this.$router.push("/pages/login").catch(() => {});
      }
    },
    bodyOverlay() {
      return this.$store.state.main.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default")
          return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced")
          return "content-area-lg";
        else return "content-area-full";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.main.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.main.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.main.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.main.windowWidth;
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 1200)
      ) {
        this.$store.commit("main/TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("main/updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("main/TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
  },
  created() {
    //this.$store.dispatch("auth/getPermission");

    const color =
      this.navbarColor == "#fff" && this.isThemeDark
        ? "#10163a"
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.main.mainLayoutType);
  },
};
</script>